import React, { useState } from "react";
import {
  FaRoad,
  FaSchool,
  FaHospital,
  FaBuilding,
  FaMapMarkerAlt,
  FaLocationArrow,
  FaPlane,
  FaHome,
} from "react-icons/fa";

import heroImage from "../../assets/GH-Rajapur.jpg";
import locationMap from "../../assets/location.png";
import microsoftImg from "../../assets/Shadnagar.jpg";
import inorbitImg from "../../assets/NH44.webp";
import apolloImg from "../../assets/Shadnagar-Town.jpg";
import schoolImg from "../../assets/Educational-Inst.avif";
import financialImg from "../../assets/RGI-Airport.jpg";
import lakeImg from "../../assets/ORR.jpg";
import cityViewImg from "../../assets/experience-visit.png";
import visitImage from "../../assets/GH–HealthVillage.jpg";
import gallery1 from "../../assets/Gallery1.jpg";
import gallery2 from "../../assets/Gallery2.jpg";
import gallery3 from "../../assets/Gallery3.jpg";
import gallery4 from "../../assets/Gallery4.jpg";

import { useNavigate } from "react-router-dom";
import { submitToGoogleSheets, validateFormData, isValidEmail, isValidPhone } from "../../utils/googleSheets";

const GoldenHeightsRajapur = () => {
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    visitDate: "",
  });
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState({ type: "", message: "" });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFeedback({ type: "", message: "" });

    const { isValid } = validateFormData(
      formData,
      ["name", "phone", "email", "visitDate"]
    );

    if (!isValid || !isValidEmail(formData.email) || !isValidPhone(formData.phone)) {
      setFeedback({
        type: "error",
        message: "Please fill all fields correctly (valid email & 10-digit phone)",
      });
      setLoading(false);
      return;
    }

    try {
      await submitToGoogleSheets(
        {
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          visitDate: formData.visitDate,
          projectName: "Golden Heights @ Rajapur",
        },
        "project-site-visit"
      );

      setFeedback({
        type: "success",
        message: "Visit scheduled successfully! We'll contact you soon.",
      });

      setFormData({
        name: "",
        phone: "",
        email: "",
        visitDate: "",
      });

      setTimeout(() => {
        setFeedback({ type: "", message: "" });
      }, 3000);
    } catch (error) {
      console.error("Form submission error:", error);
      setFeedback({
        type: "error",
        message: "Error scheduling visit. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <section className="relative min-h-[420px] sm:min-h-[600px] flex items-center">
  {/* Background */}
  <div className="absolute inset-0">
    <img
      src={heroImage}
      alt="Aduri’s Golden Heights @ Rajapur"
      className="w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/20" />
  </div>

  {/* Content */}
  <div className="relative z-10 w-full">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl text-white pt-12 sm:pt-16 px-2 sm:px-4 lg:pl-16">

        {/* TITLE */}
        <h1 className="text-2xl sm:text-4xl lg:text-6xl font-bold mb-3 sm:mb-6 leading-snug">
          Aduri’s Golden Heights @ Rajapur
        </h1>

        {/* SUB TITLE */}
        <h2 className="text-sm sm:text-lg lg:text-2xl text-gray-200 mb-3 sm:mb-6">
          Premium Open Plots Near NH-44 | Shadnagar
        </h2>

        {/* DESCRIPTION */}
        <p className="text-xs sm:text-base lg:text-lg text-gray-300 mb-4 sm:mb-5 leading-relaxed">
          DTCP & TS RERA Approved Plotted Development, just 1 km from Hyderabad–Bangalore Highway (NH-44). Clear Title | Vaastu-Compliant | High Growth Investment Zone.
        </p>

        {/* PRICE */}
        <h2 className="text-sm sm:text-lg lg:text-2xl text-gray-200 mb-5 sm:mb-6 font-semibold">
          Starting from ₹13,799 / sq. yd
        </h2>

        {/* CTA BUTTONS */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-5">
          <button
            onClick={() => navigate("/contact")}
            className="bg-primary text-white px-6 sm:px-8 py-2.5 sm:py-3.5 rounded-md shadow-lg text-sm sm:text-base"
          >
            Get Pricing
          </button>

          <button
            onClick={() => navigate("/#site-visit")}
            className="bg-white text-primary border border-primary px-6 sm:px-8 py-2.5 sm:py-3.5 rounded-md text-sm sm:text-base"
          >
            Book Site Visit
          </button>
        </div>

      </div>
    </div>
  </div>
</section>


      {/* ================= LOCATION ADVANTAGES ================= */}
<section className="pt-10 pb-20 bg-white">
  <div className="max-w-7xl mx-auto px-4 lg:px-8">

    {/* Heading */}
    <div className="text-center mb-16">
      <h2 className="text-3xl font-bold text-primary mb-3">
        Location Advantages
      </h2>
      <p className="text-slate-600 max-w-2xl mx-auto">
        Strategically positioned for seamless connectivity, daily convenience, and long-term value.
      </p>
    </div>

    {/* Content */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">

      {/* ================= LEFT : KEY BENEFITS ================= */}
<div className="w-full">
  <h3 className="text-lg font-semibold text-primary mb-8">
    Key Location Benefits
  </h3>

  <div className="space-y-8">
    {[
      {
        icon: <FaRoad />,
        title: "Near NH-44 (Hyderabad–Bangalore Highway)",
        desc:
          "Just 1 km from NH-44, offering fast access to Hyderabad and Bangalore.",
      },
      {
        icon: <FaSchool />,
        title: "Close to Shadnagar",
        desc:
          "Located in a rapidly developing residential and industrial growth zone.",
      },
      {
        icon: <FaHospital />,
        title: "Excellent Road Connectivity",
        desc:
          "Well-connected internal roads with easy access to nearby towns and employment hubs.",
      },
      {
        icon: <FaBuilding />,
        title: "Future Infrastructure Growth",
        desc:
          "Surrounded by upcoming residential layouts, logistics zones, and commercial development.",
      },
    ].map((item, index) => (
      <div key={index} className="flex items-start gap-5">
        {/* Icon */}
        <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary/10 text-primary text-base shrink-0">
          {item.icon}
        </div>

        {/* Text */}
        <div>
          <h4 className="text-sm font-semibold text-slate-800 mb-1">
            {item.title}
          </h4>
          <p className="text-sm text-slate-600 leading-relaxed">
            {item.desc}
          </p>
        </div>
      </div>
    ))}
  </div>

  {/* Button */}
  <div className="flex justify-center pt-6">
  <button 
  onClick={() =>
    document
      .getElementById("map-section")
      ?.scrollIntoView({ behavior: "smooth" })
  }
  className="bg-primary text-white px-8 py-3 rounded-md hover:bg-primaryDark transition">
    View on Google Maps
  </button>
</div>
</div>


      {/* ================= RIGHT : IMAGE + TEXT ================= */}
      <div className="flex flex-col items-center text-center">
        <div className="rounded-xl overflow-hidden shadow-lg mb-6 w-full">
          <img
            src={locationMap}
            alt="Project Location Map"
            className="w-full object-cover"
          />
        </div>

        <p className="text-slate-500 flex items-center gap-2 text-sm">
          <FaMapMarkerAlt className="text-primary" />
          Rajapur, Near Shadnagar, Hyderabad – Telangana, 550914
        </p>
      </div>
    </div>
  </div>
</section>

      {/* ================= CONNECTIVITY & DISTANCE ================= */}
<section className="pt-10 pb-20 bg-slate-50">
  <div className="max-w-7xl mx-auto px-4 lg:px-8">

    {/* Heading */}
    <h3 className="text-center text-2xl font-bold text-primary mb-12">
      Connectivity & Distance
    </h3>

    {/* Cards */}
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">

      {[
        {
          icon: <FaPlane />,
          title: "RGI Airport",
          subtitle: "Rajiv Gandhi International Airport",
          distance: "Approx. 45–50 mins",
          progress: "w-[25%]",
        },
        {
          icon: <FaRoad />,
          title: "NH-44 Highway",
          subtitle: "National Highway 44",
          distance: "1 km",
          progress: "w-[40%]",
        },
        {
          icon: <FaHome />,
          title: "Shadnagar Town",
          subtitle: "Approx. 10–15 mins",
          distance: "4.5 km",
          progress: "w-[70%]",
        },
        {
          icon: <FaLocationArrow />,
          title: "Outer Ring Road (ORR)",
          subtitle: "Approx. 30–35 mins",
          distance: "30km",
          progress: "w-[85%]",
        },
      ].map((item, index) => (
        <div
          key={index}
          className="bg-white rounded-xl p-6 text-center shadow-sm border border-slate-100"
        >
          {/* Icon */}
          <div className="text-primary text-2xl mb-4 flex justify-center">
            {item.icon}
          </div>

          {/* Title */}
          <h4 className="font-semibold text-slate-800 mb-1">
            {item.title}
          </h4>

          {/* Subtitle */}
          <p className="text-xs text-slate-500 mb-3">
            {item.subtitle}
          </p>

          {/* Distance */}
          <p className="text-sm font-semibold text-primary mb-4">
            {item.distance}
          </p>

          {/* Progress Bar */}
          <div className="h-1.5 bg-slate-200 rounded-full overflow-hidden">
            <div
              className={`h-full bg-primary rounded-full ${item.progress}`}
            />
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* ================= NEARBY LANDMARKS ================= */}
<section className="pt-10 pb-10 bg-white">
  <div className="max-w-7xl mx-auto px-4 lg:px-8">
    <h3 className="text-center text-2xl font-bold text-primary mb-12">
      Nearby Landmarks
    </h3>

    <div className="grid md:grid-cols-3 gap-10">
      {[
        {
          img: microsoftImg,
          title: "Shadnagar Industrial Area",
          desc: "A fast-growing employment hub driving residential demand and land appreciation.",
        },
        {
          img: inorbitImg,
          title: "Hyderabad–Bangalore Highway (NH-44)",
          desc: "Just 1 km from the project, offering seamless connectivity to Hyderabad and Bangalore.",
        },
        {
          img: apolloImg,
          title: "Shadnagar Town",
          desc: "Well-developed town with schools, hospitals, markets, and daily conveniences nearby.",
        },
        {
          img: schoolImg,
          title: "Educational Institutions Zone",
          desc: "Multiple schools and colleges within short driving distance, ideal for family living.",
        },
        {
          img: financialImg,
          title: "Rajiv Gandhi International Airport (RGIA)",
          desc: "Easy access via NH-44 and ORR, supporting long-term investment value.",
        },
        {
          img: lakeImg,
          title: "Outer Ring Road (ORR) Connectivity",
          desc: "Quick access to ORR enables smooth travel to IT corridors and key Hyderabad locations.",
        },
      ].map((item, i) => (
        <div key={i} className="space-y-4 max-w-sm mx-auto">
  {/* Image */}
  <div className="rounded-xl overflow-hidden">
    <img
      src={item.img}
      alt={item.title}
      className="h-44 w-full object-cover"
    />
  </div>

  {/* Content */}
  <div>
    <h4 className="font-semibold text-slate-900 mb-1">
      {item.title}
    </h4>

   

    <p className="text-sm text-slate-600 leading-relaxed">
      {item.desc}
    </p>
  </div>
</div>

      ))}
    </div>
  </div>
</section>

{/* PROJECT GALLERY */}
<section className="pt-10 pb-20 bg-white">
  <div className="max-w-7xl mx-auto px-4 lg:px-8">

    {/* Heading */}
    <div className="mb-12">
      <h2 className="text-3xl font-bold text-primary mb-2">
        Project Gallery
      </h2>
      <p className="text-slate-600">
        Explore our project through these carefully curated visuals
      </p>
    </div>

    {/* Images Grid */}
    <div className="grid md:grid-cols-4 gap-8">
      {[
        { image: gallery1, label: "Outdoor Community Seating Area" },
        { image: gallery2, label: "Grand Entrance & Landscaped Driveway" },
        { image: gallery3, label: "Recreational Pool & Leisure Zone" },
        { image: gallery4, label: "Private Poolside Relaxation Area" },
      ].map((item, index) => (
        <div key={index}>
          <div className="overflow-hidden rounded-lg">
            <img
              src={item.image}
              alt={item.label}
              className="w-full h-56 object-cover hover:scale-105 transition duration-500"
            />
          </div>
          <p className="mt-3 text-sm text-slate-600">
            {item.label}
          </p>
        </div>
      ))}
    </div>

  </div>
</section>



      {/* ================= EXPERIENCE LOCATION ADVANTAGE ================= */}
<section className="pt-10 pb-10">
  <div className="max-w-7xl mx-auto px-4 lg:px-8">
    <div className="bg-primary rounded-2xl p-8 lg:p-12 grid lg:grid-cols-2 gap-12 items-center">

      {/* LEFT CONTENT */}
      <div className="text-white">
        <h3 className="text-2xl font-bold mb-3">
          Ready to Invest in a High-Growth Location?
        </h3>

        <p className="text-sm text-white/80 mb-6 max-w-md">
          Schedule a site visit to explore Aduri’s Golden Heights @ Rajapur and secure your premium plot at an early-stage price.
        </p>

        {/* FORM CARD */}
        <div className="bg-white rounded-xl p-6 text-slate-800 max-w-md">
          <h4 className="font-semibold text-primary mb-4">
            Request Site Visit
          </h4>

          {feedback.message && (
            <div
              className={`mb-4 p-3 rounded-md text-sm font-medium ${
                feedback.type === "success"
                  ? "bg-green-100 text-green-800 border border-green-300"
                  : "bg-red-100 text-red-800 border border-red-300"
              }`}
            >
              {feedback.message}
            </div>
          )}

          <form className="grid grid-cols-2 gap-4" onSubmit={handleSubmit}>
            <div className="col-span-1">
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Your Name <span className="text-red-500">*</span>
        </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Your Name"
              className="border rounded-md px-4 py-2.5 text-sm col-span-1 w-full"
            />
          </div>
          <div className="col-span-1">
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Phone Number <span className="text-red-500">*</span>
        </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="Phone Number"
              className="border rounded-md px-4 py-2.5 text-sm col-span-1 w-full"
            />
          </div>

          <div className="col-span-2">
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Email Address <span className="text-red-500">*</span>
        </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Email Address"
              className="w-full border rounded-md px-4 py-3 text-sm"
            />
          </div>

            <input 
              type="date"
              name="visitDate"
              value={formData.visitDate}
              onChange={handleInputChange}
              className="border rounded-md px-4 py-2.5 text-sm col-span-2 w-full"
            />

            <button
              type="submit"
              disabled={loading}
              className="col-span-2 bg-primary text-white py-3 rounded-md text-sm font-medium hover:bg-primaryDark transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Scheduling..." : "Schedule Now"}
            </button>
          </form>
        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div className="flex flex-col items-center">
        <div className="rounded-xl overflow-hidden shadow-lg">
          <img
            src={cityViewImg}
            alt="Location Map View"
            className="w-full h-full object-cover"
          />
        </div>

        <button 
        onClick={() =>
    document
      .getElementById("map-section")
      ?.scrollIntoView({ behavior: "smooth" })
  }
        className="mt-4 bg-white text-primary px-6 py-2.5 rounded-md text-sm font-medium shadow hover:bg-slate-100 transition">
          View Detailed Location Map
        </button>
      </div>

    </div>
  </div>
</section>


{/* MAP */}
      <section 
      id="map-section"
  className="mb-20">
        <h3 className="text-center text-xl text-primary font-bold mb-6">Find Us on Map</h3>

        <div className="max-w-6xl mx-auto h-[260px] sm:h-[350px] rounded-xl overflow-hidden">
          <iframe
      title="Office Location"
      src="https://www.google.com/maps?q=3rd%20Floor,%20Plot%20No.%2014,%20Lodha%20Road,%205th%20Phase,%20KPHB,%20Hyderabad&output=embed"
      className="w-full h-[260px] lg:h-full border-0"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
        </div>
      </section>


<section className="pt-10 pb-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="bg-sky-100 rounded-3xl overflow-hidden grid lg:grid-cols-2 items-center">

          {/* LEFT CONTENT */}
          <div className="p-10 lg:p-14">
            <h2 className="text-3xl lg:text-4xl font-bold text-primary mb-6">
              Schedule a Site Visit
            </h2>

            <p className="text-slate-600 text-lg leading-relaxed mb-10 max-w-xl">
              Experience our project firsthand. Schedule a site visit at your
              convenient time and our representative will assist you.
            </p>

            <div className="flex flex-wrap gap-4">
              <button
  onClick={() => navigate("/#site-visit")}
  className="bg-primary text-white px-8 py-3 rounded-lg font-medium"
>
  Book Site Visit
</button>

              <a
  href="tel:+918374249705"
  className="border border-primary text-primary px-8 py-3 rounded-lg font-medium hover:bg-white transition"
>
  Call Now
</a>

            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="h-full">
            <img
              src={visitImage}
              alt="Schedule Site Visit"
              className="w-full h-full object-cover rounded-tr-3xl rounded-br-3xl"
            />
          </div>
        </div>
      </div>
    </section>

    </>
  );
};

export default GoldenHeightsRajapur;
